/**
 * Shared academic-year helper for the Admission Analytics module.
 *
 * Every `/admission/admitted/*` query (see `admittedAnalyticsApi.ts`) needs
 * the current admission cycle in the `"YYYY-YY"` format the backend expects
 * (e.g. `"2026-27"`). This is the single source of truth for "which cycle",
 * used across all of this module's screens.
 */

/**
 * Compute the current academic-year query value in the `"YYYY-YY"` format the
 * endpoint expects (e.g. `"2026-27"`). The Indian academic year runs
 * April–March, so a date in Jan–Mar belongs to the session that started the
 * previous calendar year.
 */
export function getCurrentAcademicYearParam(): string {
  const now = new Date();
  const calendarYear = now.getFullYear();
  const startYear = now.getMonth() >= 3 ? calendarYear : calendarYear - 1; // Apr = month 3
  const endYearSuffix = String((startYear + 1) % 100).padStart(2, '0');
  return `${startYear}-${endYearSuffix}`;
}
